import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { HearingSegment } from '../court';
import { Money } from './Money';
/**
 * Details of a request for a feature/product from a customer
 */
export class LineItem {
}
__decorate([
    Type(() => HearingSegment),
    __metadata("design:type", Array)
], LineItem.prototype, "hearingSegments", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], LineItem.prototype, "finalPrice", void 0);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isOrderWorkflowLineItem(lineItem) {
    const assumedType = lineItem;
    return assumedType.id !== undefined && assumedType.type !== undefined;
}
